import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Coins, X } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Button } from "./ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtDate = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });

export default function WageRateBanner() {
  const { isSuperAdmin, masterCode } = useAuth();
  const [st, setSt] = useState(null);
  const [hideReminder, setHideReminder] = useState(false);
  const headers = { headers: { "x-master-code": masterCode } };

  const load = () => axios.get(`${API}/labour/wage-rates/banner`, headers).then((r) => setSt(r.data)).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (isSuperAdmin && masterCode) load(); }, [isSuperAdmin, masterCode]);
  if (!isSuperAdmin || !st) return null;

  const act = async (path, msg) => {
    try { await axios.post(`${API}/labour/wage-rates/${path}`, {}, headers); toast.success(msg); load(); }
    catch { toast.error("Action failed"); }
  };

  if (st.pending) {
    return (
      <div className="mb-3 flex flex-wrap items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900" data-testid="wage-rate-banner">
        <Coins size={18} className="shrink-0" />
        <span className="flex-1 font-semibold" data-testid="wage-rate-banner-text">
          New National Living Wage found: £{st.pending.rate.toFixed(2)} from {fmtDate(st.pending.effective_from)}. Apply?
        </span>
        <Button onClick={() => act("approve", "New rate applied from its effective date")} className="h-8 text-xs bg-amber-600 hover:bg-amber-700 text-white" data-testid="wage-rate-approve">Apply</Button>
        <Button onClick={() => act("dismiss", "Dismissed — rate unchanged")} variant="outline" className="h-8 text-xs" data-testid="wage-rate-dismiss">Not now</Button>
      </div>
    );
  }
  if (st.march_reminder && !hideReminder) {
    return (
      <div className="mb-3 flex flex-wrap items-center gap-3 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-900" data-testid="wage-rate-march-reminder">
        <Coins size={18} className="shrink-0" />
        <span className="flex-1">
          The National Living Wage changes on 1 April and no April {st.reminder_year} rate has been approved yet.
          Check GOV.UK or add it in <Link to="/kpi?tab=labour" className="underline font-semibold">Labour Plan → Rates</Link>.
        </span>
        <button onClick={() => setHideReminder(true)} aria-label="Hide for now" data-testid="wage-rate-reminder-hide"><X size={16} /></button>
      </div>
    );
  }
  return null;
}
